import { render, staticRenderFns } from "./ThxPage.vue?vue&type=template&id=7047a6d7&scoped=true&"
import script from "./ThxPage.vue?vue&type=script&lang=js&"
export * from "./ThxPage.vue?vue&type=script&lang=js&"
import style0 from "./ThxPage.vue?vue&type=style&index=0&id=7047a6d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7047a6d7",
  null
  
)

export default component.exports